<template>
  <HeroSliderEvent
    v-if="event"
    :content="content"
    :event="event"
    :loading="loading"
  />
  <HeroSliderPage
    v-else
    :content="content"
    :loading="loading"
  />
</template>

<script setup lang="ts">
  import type { HeroSlideContent, HeroSlideResolvedEvent } from '@/types/heroSlider'

  defineProps<{
    content: HeroSlideContent
    event?: HeroSlideResolvedEvent
    loading?: 'eager' | 'lazy'
  }>()
</script>
